import { motion, useInView } from 'motion/react';
import { useRef } from 'react';
import { useIntlayer } from 'react-intlayer';

import { AnimatedWords } from '~/components/ui/animated-words';
import { HlsVideo } from '~/components/ui/hls-video';

export const HeroSection = () => {
  const { hero } = useIntlayer('landing');
  const titleRef = useRef<HTMLHeadingElement>(null);
  const isInView = useInView(titleRef, { once: true, amount: 0.3 });

  return (
    <section className="relative h-[100dvh] w-full overflow-hidden">
      <div className="absolute inset-0">
        <HlsVideo
          src="/assets/video/hls/hero_section_2/master.m3u8"
          fallbackSrc="/assets/video/hero_section_2.mp4"
          className="absolute inset-0 size-full bg-black object-cover object-center w-full h-full"
          playsInline
          loop
          muted
          autoPlay
          aria-label="Background video"
          poster='/assets/images/first_frame.png'
        />
      </div>
      <div className="absolute left-[16px] right-[16px] top-[50%] translate-y-[-19px] md:translate-y-[-38px] mx-auto">
        <h1
          ref={titleRef}
          className="font-manrope font-normal text-white text-[38px] leading-[1.2] lg:text-[76px] max-w-full uppercase text-center"
        >
          <AnimatedWords
            text={hero.title.value as string}
            as="span"
            isInView={isInView}
            wordClassName="will-change-transform"
            initial={{ y: '100%', opacity: 0 }}
            animate={{ y: '0%', opacity: [0, 1, 1, 0] }}
            transition={{
              duration: 7,
              ease: [0.25, 0.1, 0.25, 1],
              opacity: {
                duration: 7,
                times: [0, 0.2, 0.8, 1],
                ease: 'easeInOut',
              },
              y: {
                duration: 1,
                ease: 'easeInOut',
              },
            }}
            delayStep={0.01}
          />
        </h1>
        <motion.div
          className="mt-[140px]"
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: [0, 1, 1, 0], y: 0 } : { opacity: 0, y: 20 }}
          transition={{
            duration: 7,
            ease: [0.4, 0, 0.2, 1],
            delay: 0.5,
            opacity: {
              duration: 7,
              times: [0, 0.2, 0.8, 1],
              ease: 'easeInOut',
              delay: 0.5,
            },
            y: {
              duration: 0.8,
              ease: 'easeInOut',
              delay: 0.5,
            },
          }}
        >
          <p className="font-fragment-mono text-white text-sm tracking-[0.14px] uppercase text-center">
            {hero.subtitle.line1}<br />
            {hero.subtitle.line2}
          </p>
        </motion.div>
      </div>

    </section>
  );
};
